import {Pipe, PipeTransform} from '@angular/core';
import {distinctUntilChanged, Observable, of, switchMap, timer} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
    name: 'dateDifference',
    standalone: false
})
export class DateDifferencePipe implements PipeTransform {
  constructor(private readonly translate: TranslateService) {
  }

  transform(value: Date | string | number | null | undefined): Observable<string> {
    return timer(0, 5000).pipe(switchMap(() => {
      // Guard against null/undefined inputs
      if (value == null) {
        return of('');
      }

      // Normalize to a Date instance (handles ISO strings from JSON deserialization, epoch numbers, or existing Dates)
      const date = value instanceof Date ? value : new Date(value);

      // Guard against invalid dates
      if (isNaN(date.getTime())) {
        return of('');
      }

      let result: { unit: string, time?: number };
      // current time
      let now = new Date().getTime();

      // time since message was sent in seconds
      let delta = (now - date.getTime()) / 1000;

      // format string
      if (delta < 10) {
        result = {unit: 'now'};
      } else if (delta < 60) { // sent in last minute
        result = {unit: 'seconds', time: Math.floor(delta)};
      } else if (delta < 3600) { // sent in last hour
        result = {unit: 'minutes', time: Math.floor(delta / 60)};
      } else if (delta < 86400) { // sent on last day
        result = {unit: 'hours', time: Math.floor(delta / 3600)};
      } else { // sent more than one day ago
        result = {unit: 'days', time: Math.floor(delta / 86400)};
      }
      return this.translate.get('timeDifference.' + result.unit, {time: result.time});
    }), distinctUntilChanged());
  }
}
